// extracted by mini-css-extract-plugin
export default {"container":"AddressInfo_container__fK8zn","title":"AddressInfo_title__cfv40","content":"AddressInfo_content__LuoRv","tel":"AddressInfo_tel__xI5iZ"};